<!-- <p>Relays: {{ Object.keys(relays) }}</p> -->
<template>
  <div class="main">
    <div id="header">
      <Publish />
    </div>
    <div id="article">
      <div v-if="$store.state.home.size === 0">
        <p>Didn't find any notes to show.</p>
      </div>
      <List v-else :notes="$store.state.home.values()" />
    </div>
    <div id="aside"></div>
    <div id="nav"></div>
  </div>
</template>

<script>
  import { pool } from "./relay";

  export default {
    computed: {
      relays() {
        return pool.relays;
      }
    }
  };
</script>

<style>
  .main {
    display: grid;
    grid-template-areas:
      "header"
      "article"
      "aside"
      "nav";
    grid-template-rows: 100% 1fr 70px 1fr 70px;
    grid-template-columns: 1fr;
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    min-height: 100vh;
    height: 100%;
  }
  #header,
  #article,
  #aside,
  #nav {
    background: gold;
  }
  #header {
    grid-area: header;
    background: none;
  }
  #article {
    grid-area: article;
    background: none;
  }
  #aside {
    grid-area: aside;
  }
  #nav {
    grid-area: nav;
  }
  @media all and (min-width: 768px) {
    .main {
      grid-template-areas:
        "nav header aside"
        "nav article aside"
        "nav article aside";
      grid-template-rows: auto 1fr 0.3fr;
      grid-template-columns: 20% 1fr 15%;
    }
  }
</style>
